import React from 'react'
import QuoteList from './QuoteList'
import NewQuote from './NewQuote'
import ViewQuote from './ViewQuote'
import EditQuote from './EditQuote'
import { Route, Routes } from 'react-router-dom';

export default function QuoteRoute() {
     return (
          <Routes>
               <Route path="/" element={<QuoteList />} />
               <Route path="/new" element={<NewQuote />} />
               <Route path="/view/:id" element={<ViewQuote />} />
               <Route path="/edit/:id" element={<EditQuote />} />
          </Routes>
     )
}
